import React from "react";
import styles from "./RefreshGridButton.module.css";
import { ThreeCircles } from "react-loader-spinner";
import * as Icon from "react-bootstrap-icons";
import { RefreshGridButtonProps } from "./RefreshGridButton.utils";

/**
 * RefreshGridButton Component
 */
const RefreshGridButton: React.FC<RefreshGridButtonProps> = ({
  refreshGridApiProgress,
  handleRefresh,
}) => {
  return (
    <>
      {refreshGridApiProgress ? (
        <ThreeCircles
          height="20"
          width="20"
          color="#4fa94d"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          ariaLabel="three-circles-rotating"
          outerCircleColor="var(--theme1_tertiary)"
          innerCircleColor="var(--theme1_secondary)"
          middleCircleColor="var(--theme1_primary)"
        />
      ) : (
        <Icon.ArrowCounterclockwise
          onClick={() => handleRefresh()}
          className={styles.refreshIcon}
        />
      )}
    </>
  );
};

export default RefreshGridButton;
